module.exports = __webpack_public_path__ + "img/exercise_passed.a280d729.png";